import React, { useState, useEffect } from "react";

export default function Sidebar({
    isOpen,
    onClose,
    onLogout,
    visibleItems,
    setVisibleItems,
    handleDataUpdate,
    userRights,
    isAdmin,
}) {
    const [localVisibleItems, setLocalVisibleItems] = useState(visibleItems);

    useEffect(() => {
        if (isOpen) {
            setLocalVisibleItems(visibleItems);
        }
    }, [isOpen, visibleItems]);

    const handleToggleItem = (item) => {
        setLocalVisibleItems((prev) => ({
            ...prev,
            [item]: {
                ...prev[item],
                show: !prev[item].show,
            },
        }));
    };

    const handleClose = () => {
        setVisibleItems(localVisibleItems);
        onClose();
    };

    return (
        <>
            {isOpen && <div className="overlay" onClick={handleClose}></div>}
            <div
                className={`sidebar d-flex flex-column p-3 text-white ${
                    isOpen ? "open" : ""
                }`}
            >
                <button
                    className="btn-close btn-close-white align-self-start"
                    onClick={handleClose}
                ></button>
                <h4 className="text-center mb-4">Налаштування</h4>

                <div className="flex-grow-1">
                    {Object.keys(localVisibleItems).map((item) => {
                        const userRightKey = `ur${item
                            .charAt(0)
                            .toUpperCase()}${item.slice(1)}`;

                        if (userRights[userRightKey] !== 1 && isAdmin !== 1)
                            return null;

                        return (
                            <div
                                className="form-check form-switch my-3"
                                key={item}
                            >
                                <input
                                    className="form-check-input bg-secondary border-0"
                                    type="checkbox"
                                    id={item}
                                    checked={localVisibleItems[item].show}
                                    onChange={() => handleToggleItem(item)}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={item}
                                >
                                    {localVisibleItems[item].label}
                                </label>
                            </div>
                        );
                    })}
                </div>

                <div className="mt-auto w-100 d-flex justify-content-between">
                    <button
                        className="btn main--button"
                        onClick={handleDataUpdate}
                    >
                        Оновити дані
                    </button>

                    <button className="btn main--button" onClick={onLogout}>
                        Вихід
                    </button>
                </div>
            </div>
        </>
    );
}
